import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import ScrollSmoother from 'gsap/ScrollSmoother'

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, ScrollSmoother)

ScrollSmoother.create({
    smooth: 1,
    effects: true,
})

const wrapper = document.querySelector('.parallaxWrapper')
const heading = document.querySelector('.parallaxHeading')
const boxes = gsap.utils.toArray('.parallaxBox')
const navLinks = gsap.utils.toArray('.parallaxHeading ul li a')

const lastBox = boxes[boxes.length - 1]
let lastBoxTrigger

function clearActive() {
    navLinks.forEach((link) => link.classList.remove('active'))
}

boxes.forEach((box, i) => {
    const content = box.querySelector('.rightContent')

    const trigger = ScrollTrigger.create({
        trigger: box,
        start: 'top 15%',
        end: 'bottom bottom',
        endTrigger: wrapper,
        pin: content,
        pinSpacing: false,
        markers: false,
        onEnter: () => {
            clearActive()
            navLinks[i]?.classList.add('active')
        },
        onEnterBack: () => {
            clearActive()
            navLinks[i]?.classList.add('active')
        },
    })

    if (i === boxes.length - 1) lastBoxTrigger = trigger
})

ScrollTrigger.create({
    trigger: heading,
    start: 'top 10%',
    pin: true,
    pinSpacing: false,
    markers: false,
    endTrigger: lastBox,
    end: () => lastBoxTrigger?.end || 'bottom bottom',
})

// Insights listing — pin image and nav columns while content scrolls
const insightsImageCol = document.querySelector('[data-insights-col="image"]')
const insightsNavCol = document.querySelector('[data-insights-col="nav"]')
const insightsContentCol = document.querySelector('[data-insights-col="content"]')

if (insightsImageCol && insightsNavCol && insightsContentCol) {
    gsap.matchMedia().add('(min-width: 1280px)', () => {
        ScrollTrigger.create({
            trigger: insightsContentCol,
            start: 'top top',
            end: 'bottom bottom',
            pin: insightsImageCol,
            pinSpacing: false,
        })
        ScrollTrigger.create({
            trigger: insightsContentCol,
            start: 'top top',
            end: 'bottom bottom',
            pin: insightsNavCol,
            pinSpacing: false,
        })

    })
}

navLinks.forEach((link, i) => {
    link.addEventListener('click', (e) => {
        e.preventDefault()
        const targetId = link.getAttribute('href').substring(1)
        const targetBox = document.getElementById(targetId).closest('.parallaxBox')

        const smoother = ScrollSmoother.get()
        smoother.scrollTo(targetBox, true)
    })
})
